import { scrollTo } from './utils';

const slideDown = function () {

    if ($(this).is(':visible')) return;

    gsap.set(
        $(this),
        {
            display: 'block',
            height: 0,
            overflow: 'hidden',
        }
    );

    gsap.to(
        $(this),
        {
            height: 'auto',
            ease: 'none',
            duration: 0.3,
        }
    );

    return $(this);
};

const slideUp = function () {

    if (!$(this).is(':visible')) return;

    gsap.set(
        $(this),
        {
            overflow: 'hidden',
        }
    );

    gsap.to(
        $(this),
        {
            height: 0,
            onComplete: () => {
                gsap.set(
                    $(this),
                    {
                        display: 'none',
                    }
                );
            },
        }
    );

    return $(this);
};

const scrollIntoView = function (options = {}) {

    scrollTo($(this), options);

    return $(this);
};

const register = () => {

    $.fn.slideDown = slideDown;
    $.fn.slideUp = slideUp;
    $.fn.scrollIntoView = scrollIntoView;
};

export default {
    register,
};

